var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { color: "accent", block: "", dark: "" },
          on: { click: _vm.newVehicle }
        },
        [_vm._v(_vm._s(_vm.$t("vehicleForm.newVehicleButton")))]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.newDialog,
            callback: function($$v) {
              _vm.newDialog = $$v
            },
            expression: "newDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "error-messages":
                                        _vm.translatedErrors.plates,
                                      label: _vm.$t(
                                        "vehicleForm.fields.plates.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.editedVehicle.plates,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedVehicle,
                                          "plates",
                                          $$v
                                        )
                                      },
                                      expression: "editedVehicle.plates"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "error-messages":
                                        _vm.translatedErrors.model,
                                      label: _vm.$t(
                                        "vehicleForm.fields.model.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.editedVehicle.model,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedVehicle,
                                          "model",
                                          $$v
                                        )
                                      },
                                      expression: "editedVehicle.model"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "error-messages":
                                        _vm.translatedErrors.engine_capacity,
                                      label: _vm.$t(
                                        "vehicleForm.fields.engineCapacity.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.editedVehicle.engine_capacity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedVehicle,
                                          "engine_capacity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editedVehicle.engine_capacity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6", md: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.vehicleTypes,
                                      "item-value": "id",
                                      "error-messages":
                                        _vm.translatedErrors.type,
                                      "item-text": "name",
                                      label: _vm.$t(
                                        "vehicleForm.fields.type.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.editedVehicle.type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedVehicle, "type", $$v)
                                      },
                                      expression: "editedVehicle.type"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6", md: "6" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "vehicleForm.fields.isPrivate.name"
                                      ),
                                      "error-messages":
                                        _vm.translatedErrors.is_private
                                    },
                                    model: {
                                      value: _vm.editedVehicle.is_private,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedVehicle,
                                          "is_private",
                                          $$v
                                        )
                                      },
                                      expression: "editedVehicle.is_private"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.save }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.editedVehicle.id === null
                            ? _vm.$t("global.add")
                            : _vm.$t("global.save")
                        ) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }